<button class="btn btn-success btn-sm trigger-btn" (click)="openBuyLabelModal()"
        *ngIf="
        saleRecord.note
        && saleRecord.note.indexOf('Cần mua label') >-1
        && saleRecord.note.indexOf('Đơn đã được mua label') == -1"
        >
  Mua Label
</button>

<ng-template #buyTiktokLabelModal let-modal>
  <div class="modal-lg">
    <div class="modal-header">
      <h4 class="modal-title">Mua Tiktok label</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="width" class="form-label">Width <span *ngIf="!isUK">(in)</span><span *ngIf="isUK">(cm)</span></label>
            <input type="number" class="form-control" id="width" 
                   [ngModel]="isUK ? displayDimension.width : buyLabelRequest.dimension.width"
                   (ngModelChange)="isUK ? displayDimension.width = $event : buyLabelRequest.dimension.width = $event"
                   [placeholder]="isUK ? 'Enter width in cm' : 'Enter width in inches'"
                   step="0.01">
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="height" class="form-label">Height <span *ngIf="!isUK">(in)</span><span *ngIf="isUK">(cm)</span></label>
            <input type="number" class="form-control" id="height" 
                   [ngModel]="isUK ? displayDimension.height : buyLabelRequest.dimension.height"
                   (ngModelChange)="isUK ? displayDimension.height = $event : buyLabelRequest.dimension.height = $event"
                   [placeholder]="isUK ? 'Enter height in cm' : 'Enter height in inches'"
                   step="0.01">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="length" class="form-label">Length <span *ngIf="!isUK">(in)</span><span *ngIf="isUK">(cm)</span></label>
            <input type="number" class="form-control" id="length" 
                   [ngModel]="isUK ? displayDimension.length : buyLabelRequest.dimension.length"
                   (ngModelChange)="isUK ? displayDimension.length = $event : buyLabelRequest.dimension.length = $event"
                   [placeholder]="isUK ? 'Enter length in cm' : 'Enter length in inches'"
                   step="0.01">
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="weight" class="form-label">Weight <span *ngIf="!isUK">(lb)</span><span *ngIf="isUK">(g)</span></label>
            <input type="number" class="form-control" id="weight" 
                   [ngModel]="isUK ? displayWeight : buyLabelRequest.weight"
                   (ngModelChange)="isUK ? displayWeight = $event : buyLabelRequest.weight = $event"
                   [placeholder]="isUK ? 'Enter weight in grams' : 'Enter weight in pounds'" 
                   step="0.1">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="closeModal()">Cancel</button>
      <button type="button" class="btn btn-outline-primary" (click)="buyTiktokLabel()">Mua</button>
    </div>
  </div>
</ng-template>
